export default __webpack_public_path__ + "static/media/controls-alt.a28582a3.svg";